module.exports = __webpack_public_path__ + "static/daiwik-45015e2b719966dd80630eed4ffa32ad.jpeg";